(function() {

    const classes = {
        letterNav: "letter-nav",
        letterNavItem: "letter-nav-item",
        letterSection: "letter-section",
        letterSectionHeader: "letter-section-header",
        letterSectionBrands: "letter-section-brands"
    };

    const selectors = {
        brandList: ".js-brand-list",
        brandItems: ".brand",
        catNavItems: ".js-cat-nav a",
        letterSection: "."+classes.letterSection,
        letterNavItem: "."+classes.letterNavItem,
        pageheader: ".js-site-header"
    };

    const letterNavContent = Array("0-9","A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","Q","R","S","T","U","V","W","X","Y","Z");

    let sectionHasFocus = false;
    let headerHeight = jQuery(selectors.pageheader).height();
    let $brandlist = jQuery(selectors.brandList);
    let $letterNav;
    let $letterNavItems;
    let $letterSections;
    let $catNavItems = jQuery(selectors.catNavItems);
    let $brandItems = $brandlist.find(selectors.brandItems);

    function createLetterNav() {
        $letterNav = jQuery("<nav/>", {
            "class" : classes.letterNav
        }).prependTo($brandlist);

        jQuery.each(letterNavContent, function(i, val){
            jQuery("<a/>", {
                "href" : "#section-"+val,
                "class" : classes.letterNavItem,
                "text" : val
            }).appendTo($letterNav);
        });
        $letterNavItems = jQuery(selectors.letterNavItem);
    }

    function createLetterSections() {
        jQuery.each(letterNavContent, function(i, val){
            let $letterSection = jQuery("<div/>", {
                "id" : "section-"+val,
                "class" : classes.letterSection
            }).appendTo($brandlist);

            jQuery("<div/>", {
                "class" : classes.letterSectionHeader,
                "html"  : val
            }).appendTo($letterSection);

            jQuery("<div/>", {
                "class" : classes.letterSectionBrands
            }).appendTo($letterSection);
        });
        $letterSections = jQuery(selectors.letterSection);
        
        sortBrandsInSections();
    }

    function sortBrandsInSections() {
        $brandItems.each(function(){
            let initial = jQuery(this).text().charAt(0).toUpperCase();
            if (isNaN(initial)){
                jQuery("#section-"+initial+" ."+classes.letterSectionBrands).append(jQuery(this));
            }else{
                jQuery("#section-0-9 ."+classes.letterSectionBrands).append(jQuery(this));
            }
        });

        $brandlist.addClass('initiated');
        filterLetterSections();
        setLetterNavState();
    }

    function setLetterNavState() {
        $letterNavItems.each(function(){
            let $navItem = jQuery(this);
            $navItem.removeClass("inactive");
            if ($brandlist.find($navItem.attr("href")).not(":hidden").length === 0){
                $navItem.addClass("inactive");
            }
        });
    }
    
    function filterBrands(target) {
        $brandItems.filter(
            function() {
                jQuery(this).toggle(jQuery(this).attr("data-cats").indexOf(target) > -1);
            }
        );
        filterLetterSections();
        setLetterNavState();
    }

    function filterLetterSections() {
        $letterSections.show();
        $letterSections.each(function(){
            if (jQuery(this).find(selectors.brandItems).not(":hidden").length === 0){
                jQuery(this).hide();
            }
        });
    }

    function focusLetterSection(focusOn) {
        let $focusOnSection = jQuery(focusOn);
        $letterSections.addClass("unFocus");
        $focusOnSection.removeClass("unFocus");
        
        jQuery("html, body").animate({
            scrollTop: parseInt($focusOnSection.offset().top - headerHeight-100)
        }, 500);

        setTimeout(function(){ 
            sectionHasFocus = true;
        }, 1000);
    }

    function addEvents() {
        $letterNavItems.on("click", function(e){
            e.preventDefault();
            focusLetterSection(jQuery(this).attr("href"));
        });

        $catNavItems.on("click", function(e){
            e.preventDefault();
            filterBrands(jQuery(this).attr("id"));

            jQuery("html, body").animate({
                scrollTop: parseInt($brandlist.offset().top - headerHeight - 20)
            }, 500);
        });

        jQuery(window).on("scroll", function(){
            if (sectionHasFocus){
                $letterSections.removeClass("unFocus");
                sectionHasFocus = false;
            }
        });
    }

    function init() {
        if ($brandlist.length > 0){
            createLetterNav();
            createLetterSections();
            addEvents();
        }
    }

    init();
}());
